export const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 100px 100px 120px 120px 80px',
    gap: '10px',
    alignItems: 'center',
    textAlign: 'right',
    direction: 'rtl'
}

export const headerStyle = {
    fontWeight: 'bold',
    borderBottom: '2px solid #ccc',
    paddingBottom: '10px',
    marginBottom: '10px'
}

export const rowStyle = {
    cursor: 'pointer',
    padding: '10px 0',
    borderBottom: '1px solid #eee',
    '&:hover': {
        backgroundColor: '#f5f5f5'
    }
}

export const chartContainerStyle = {
    marginTop: '0px',
    padding: '20px',
    borderTop: 'none',
    height: '50%',
}
